module.exports = __webpack_public_path__ + "img/bg_main_quick_top.4a9453c.png";